// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--zSGlD","lock":"lock--EtgLy"};